import { authors } from "@/mocks/comics";
import SectionHeading from "./SectionHeading";

export default function AuthorSection() {
  return (
    <section className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="人气创作人"
          title="追漫作者"
          desc="认识这些用画笔制造心动与甜蜜的可爱作者们。"
        />

        <div className="grid grid-cols-2 gap-5 lg:grid-cols-4">
          {authors.map((a) => (
            <div
              key={a.name}
              className="group flex flex-col items-center gap-4 rounded-2xl bg-background-100 p-6 text-center transition-colors hover:bg-accent-50"
            >
              <div className="h-24 w-24 overflow-hidden rounded-full ring-4 ring-background-50 transition-transform duration-300 group-hover:scale-105">
                <img src={a.cover} alt={`作者 ${a.name} 头像`} className="h-full w-full object-cover" />
              </div>
              <div>
                <h3 className="text-lg font-medium text-foreground-900">{a.name}</h3>
                <span className="mt-1 inline-block rounded-full bg-accent-100 px-3 py-0.5 text-xs text-accent-700">
                  {a.tag}
                </span>
              </div>
              <div className="flex items-center gap-5 text-xs text-foreground-500">
                <span>{a.works}部作品</span>
                <span className="flex items-center gap-1">
                  <i className="ri-user-heart-line text-accent-500" />
                  {a.fans}万粉丝
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}